type CreditCard = {
  nonce: string
  binData: any
}

type CreditCardResponse = {
  creditCards: CreditCard[]
}

export const hasValidCreditCardResponse = (
  response: any
): response is CreditCardResponse & { creditCards: [CreditCard] } => {
  return (
    response &&
    Array.isArray(response.creditCards) &&
    response.creditCards.length > 0 &&
    typeof response.creditCards[0].nonce === 'string' &&
    response.creditCards[0].binData !== undefined
  )
}
